import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddGarageLayer from "../../components/garages/AddGarageLayer";

const AddGaragePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb
          routePath="/all-garages"
          routeName="All Garages"
          title="Add Garage"
        />

        {/* AddUserLayer */}
        <AddGarageLayer />
      </MasterLayout>
    </>
  );
};

export default AddGaragePage;
